import _extends from "@babel/runtime/helpers/esm/extends";
// @ts-nocheck
import * as React from "react";
import { unmountComponentAtNode } from 'react-dom';
import ReactDOMType from '../utils/reactRequire';
import ToastManager from "./ToastManager";
var isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined";
var PORTAL_ID = "ap-notifications";
var defaultContainerId = 'ap-notifications';
var getInstance = function getInstance(props, containerRef, mountElement) {
  if (containerRef !== null && containerRef !== void 0 && containerRef.current) return [containerRef, destroy];
  function destroy() {
    unmountComponentAtNode(mountElement);
    // parentElement.removeChild(mountElement);
  }

  ReactDOMType(mountElement, /*#__PURE__*/React.createElement(ToastManager, _extends({
    ref: containerRef
  }, props)));
  return [containerRef, destroy];
};
var Toaster = function Toaster() {
  if (!isBrowser) {
    return;
  }
  var containers = new Map();
  var createContainer = function createContainer(containerId, props) {
    var container = props.container;
    var containerRef = /*#__PURE__*/React.createRef();
    var mountElement = document.createElement('div');
    var containerElement = typeof container === 'function' ? container() : container;
    //  Parent is document.body or the existing dom element
    var parentElement = containerElement || document.body;
    // Add the detached element to the parent
    parentElement.appendChild(mountElement);
    var _getInstance = getInstance(props, containerRef, mountElement),
      containercurRef = _getInstance[0];
    containers.set(containerId || defaultContainerId, containerRef);
    containers.set(containerId + "Ref", mountElement);
    return containercurRef;
  };
  var getContainer = function getContainer(props, containerId) {
    var containerRef = containers.get(containerId || defaultContainerId);
    var mountElement = containers.get(containerId + "Ref");
    if (containers.size == 0 || !containerRef || !mountElement) {
      return null;
    }
    var _getInstance2 = getInstance(props, containerRef, mountElement),
      container = _getInstance2[0];
    return container;
  };
  var closeAll = function closeAll() {
    containers.forEach(function (c) {
      var _c$current;
      return (_c$current = c.current) === null || _c$current === void 0 ? void 0 : _c$current.clear();
    });
  };
  var createNotification = function createNotification(notification, options) {
    if (options === void 0) {
      options = {};
    }
    var _options = options,
      _options$position = _options.position,
      position = _options$position === void 0 ? 'topCenter' : _options$position;
    var container = getContainer(options, position);
    if (!container) {
      container = createContainer(position !== null && position !== void 0 ? position : '', options);
    }
    setTimeout(function () {
      var _container, _container$current;
      return (_container = container) === null || _container === void 0 ? void 0 : (_container$current = _container.current) === null || _container$current === void 0 ? void 0 : _container$current.push(notification, options);
    });
  };
  var close = function close(id) {
    containers.forEach(function (c) {
      var _c$current2;
      return (_c$current2 = c.current) === null || _c$current2 === void 0 ? void 0 : _c$current2.remove(id);
    });
  };
  return {
    closeAll: closeAll,
    notify: createNotification,
    close: close
  };
};
var toaster = Toaster();
export { toaster };